import {
  GetBalanceResponse,
  GetTransactionsResponse,
} from '@/features/wallet/services/types';
import { cashbackUrl } from '../config';
import { createInfiniteQuery, createQuery } from '@/logic/libs';

export const useGetBalance = createQuery<GetBalanceResponse>({
  method: 'get',
  url: `${cashbackUrl}/balance`,
});

export const useGetTransactions = createQuery<GetTransactionsResponse>({
  method: 'get',
  url: `${cashbackUrl}`,
});

export const useGetInfiniteTransactions = createInfiniteQuery<GetTransactionsResponse>(
  {
    method: 'get',
    url: `${cashbackUrl}`,
  },
  {
    staleTime: 0,
    keepPreviousData: false,
  }
);

export const useGetInfiniteExpiredTransactions =
  createInfiniteQuery<GetTransactionsResponse>({
    method: 'get',
    url: `${cashbackUrl}/expired`,
  });
